<onsip-header-main>
  <onsip-header-page-title> External phone number </onsip-header-page-title>
</onsip-header-main>
<div class="pricing">
  {{ "ONSIP_I18N.PRICING" | translate }}: {{ "ONSIP_I18N.FREE" | translate }}
</div>
<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="externalPhoneNumberForm" (ngSubmit)="onSubmit()">
    <div class="external-phone-number-setup onsip-grid-placement">
      <div class="first-column">
        <section class="name with-mat-form-field property">
          <div class="mat-body-1 property-header">Name</div>
          <mat-form-field appearance="outline" class="text-field">
            <input
              matInput
              formControlName="name"
              [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_ADD_NAME_INPUT"
              autocomplete="off"
            />
            <mat-error>{{ getNameError() }}</mat-error>
          </mat-form-field>
        </section>
        <section class="ext-phone-num with-mat-form-field property">
          <div class="mat-body-1 property-header">External phone number</div>
          <mat-form-field appearance="outline" class="text-field">
            <input
              matInput
              formControlName="externalPhoneNumber"
              [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_ADD_NUMBER_INPUT"
              autocomplete="off"
            />
            @if (
            externalPhoneNumberForm.controls['externalPhoneNumber'].hasError('validPhoneNumber') ) {
            <mat-error>
              {{ "ONSIP_I18N.MUST_BE_A_VALID_PHONE_NUMBER" | translate }}
            </mat-error>
            } @if (externalPhoneNumberForm.controls['externalPhoneNumber'].hasError('required')) {
            <mat-error>
              {{ "ONSIP_I18N.PHONE_NUMBER_IS_REQUIRED" | translate }}
            </mat-error>
            }
          </mat-form-field>
        </section>
        <section class="property calling-type">
          <div class="mat-body-1 property-header">Calling type</div>
          <mat-radio-group
            color="primary"
            formControlName="callingType"
            class="calling-type-radio-group"
          >
            <mat-radio-button [value]="'restricted'" onsip-mat-radio-button-label-align-normal>
              Restricted (internet and extension-to-extension-calls)
            </mat-radio-button>
            <mat-radio-button
              class="last-radio-button"
              [value]="'unrestricted'"
              onsip-mat-radio-button-label-align-normal
            >
              Unrestricted (internet, ext-to-ext, and PSTN calls)
            </mat-radio-button>
          </mat-radio-group>
        </section>
        @if (externalPhoneNumberForm.controls.callingType.value === 'unrestricted') {
        <section class="property report-call-activity">
          <div class="mat-body-1 property-header">Report call activity under</div>
          <mat-form-field appearance="outline" onsip-form-field-flush-outline>
            <mat-select formControlName="reportCallActivity">
              @for (user of allUsers; track user) {
              <mat-option [value]="user.userId">
                {{ user.contact.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </section>
        }
        <section class="property caller-id">
          <div class="mat-body-1 property-header">Outbound caller ID</div>
          <mat-radio-group
            color="primary"
            formControlName="callerIdType"
            class="caller-id-radio-group"
          >
            <mat-radio-button [value]="'default'" onsip-mat-radio-button-label-align-normal>
              Use caller's identity info
            </mat-radio-button>
            <mat-radio-button
              [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_ADD_CALLER_ID_CUSTOM_BTN"
              [value]="'custom'"
              onsip-mat-radio-button-label-align-normal
            >
              Custom
            </mat-radio-button>
          </mat-radio-group>
          @if (this.externalPhoneNumberForm.controls.callerIdType.value === 'custom') {
          <div>
            <mat-form-field appearance="outline" class="text-field caller-id-name-field">
              <input
                [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_ADD_CALLER_ID_NAME_INPUT"
                matInput
                formControlName="customCallerIdName"
                autocomplete="off"
                placeholder="Custom name"
              />
              @if (externalPhoneNumberForm.controls.customCallerIdName.hasError('required')) {
              <mat-error> Caller ID name is required. </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="text-field">
              <input
                [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_ADD_CALLER_ID_NUMBER_INPUT"
                matInput
                formControlName="customCallerIdNumber"
                autocomplete="off"
                placeholder="Custom number"
              />
            </mat-form-field>
          </div>
          }
        </section>
      </div>
      <div class="second-column">
        <section class="extensions property">
          <div class="mat-body-1 property-header">Extensions</div>
          <onsip-extensions-list #extensionsList formControlName="extensions">
          </onsip-extensions-list>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <div class="button-wrapper cancel">
        <button mat-button class="toggle-button" color="primary" type="button" (click)="onCancel()">
          {{ "ONSIP_I18N.CANCEL" | translate }}
        </button>
      </div>
      <div class="button-wrapper">
        <button
          mat-flat-button
          class="toggle-button"
          color="primary"
          type="submit"
          [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_ADD_SUBMIT_BTN"
        >
          {{ "ONSIP_I18N.SAVE_AND_EXIT" | translate }}
        </button>
      </div>
    </div>
  </form>
</onsip-loading-container>
